import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-gray-900 dark:bg-gray-950 text-white py-6 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Copyright */}
          <div className="text-sm text-gray-400 dark:text-gray-500">
            © {new Date().getFullYear()} RefrX. All rights reserved.
          </div>
          
          {/* Powered By */}
          <div className="text-sm">
            <span className="text-gray-400 dark:text-gray-500">Powered by </span>
            <a 
              href="https://lowcostdigitalservices.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-400 dark:text-blue-500 hover:text-blue-300 dark:hover:text-blue-400 font-medium transition-colors underline"
            >
              Low Cost Digital Services
            </a>
          </div>
          
          {/* Links */}
          <div className="flex gap-6 text-sm text-gray-400 dark:text-gray-500">
            <a href="#" className="hover:text-white dark:hover:text-gray-300 transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white dark:hover:text-gray-300 transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
